const PolicyStep1Icon = ({ size = 64, className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <foreignObject x="-9" y="-9" width="82" height="82">
        <div xmlns="http://www.w3.org/1999/xhtml" style={{backdropFilter: 'blur(4.5px)', clipPath: 'url(#bgblur_0_1762_108163_clip_path)', height: '100%', width: '100%'}}></div>
      </foreignObject>
      <rect data-figma-bg-blur-radius="9" width="64" height="64" rx="32" fill="url(#paint0_linear_1762_108163)" fillOpacity="0.14"/>
      <foreignObject x="7.625" y="1.41992" width="44.8789" height="61.0801">
        <div xmlns="http://www.w3.org/1999/xhtml" style={{backdropFilter: 'blur(8.25px)', clipPath: 'url(#bgblur_1_1762_108163_clip_path)', height: '100%', width: '100%'}}></div>
      </foreignObject>
      <g filter="url(#filter1_d_1762_108163)" data-figma-bg-blur-radius="16.5">
        <path d="M29.8844 46V21.44L30.5244 18H36.0044V46H29.8844ZM24.1244 27.6V21.76C24.8444 21.8133 25.5777 21.6533 26.3244 21.28C27.0977 20.9067 27.8444 20.4133 28.5644 19.8C29.311 19.16 29.9644 18.5333 30.5244 17.92L34.6044 21.88C33.6177 23 32.5644 24.0267 31.4444 24.96C30.3244 25.8667 29.1644 26.5733 27.9644 27.08C26.7644 27.56 25.4844 27.7333 24.1244 27.6Z" fill="url(#paint1_linear_1762_108163)"/>
      </g>
      <rect x="1" y="1" width="62" height="62" rx="31" stroke="url(#paint2_linear_1762_108163)" strokeOpacity="0.6" strokeWidth="2"/>
      <defs>
        <clipPath id="bgblur_0_1762_108163_clip_path" transform="translate(9 9)">
          <rect width="64" height="64" rx="32"/>
        </clipPath>
        <filter id="filter1_d_1762_108163" x="7.625" y="1.41992" width="44.8789" height="61.0801" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="1"/>
          <feGaussianBlur stdDeviation="3.50204"/>
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.27 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1762_108163"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1762_108163" result="shape"/>
        </filter>
        <clipPath id="bgblur_1_1762_108163_clip_path" transform="translate(-7.625 -1.41992)">
          <path d="M29.8844 46V21.44L30.5244 18H36.0044V46H29.8844ZM24.1244 27.6V21.76C24.8444 21.8133 25.5777 21.6533 26.3244 21.28C27.0977 20.9067 27.8444 20.4133 28.5644 19.8C29.311 19.16 29.9644 18.5333 30.5244 17.92L34.6044 21.88C33.6177 23 32.5644 24.0267 31.4444 24.96C30.3244 25.8667 29.1644 26.5733 27.9644 27.08C26.7644 27.56 25.4844 27.7333 24.1244 27.6Z"/>
        </clipPath>
        <linearGradient id="paint0_linear_1762_108163" x1="6.84871" y1="5.90477" x2="77.0945" y2="29.7546" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0.9"/>
          <stop offset="0.447036" stopColor="white" stopOpacity="0.955296"/>
          <stop offset="1" stopColor="white" stopOpacity="0.9"/>
        </linearGradient>
        <linearGradient id="paint1_linear_1762_108163" x1="24" y1="17" x2="37.3715" y2="16.6922" gradientUnits="userSpaceOnUse">
          <stop stopColor="#ABABAB"/>
          <stop offset="1" stopColor="white"/>
        </linearGradient>
        <linearGradient id="paint2_linear_1762_108163" x1="9.21033" y1="-2.28571" x2="69.1996" y2="32.7399" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0.1"/>
          <stop offset="0.473958" stopColor="white"/>
          <stop offset="1" stopColor="white" stopOpacity="0.09"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PolicyStep1Icon; 